import { TOOLS_IDS, WATERMARK_ANNOTATION_ID } from './constants';

const TOOL_LABEL_KEYS = {
  [TOOLS_IDS.TEXT]: 'layersPanelTypeText',
  [TOOLS_IDS.IMAGE]: 'layersPanelTypeImage',
  [TOOLS_IDS.RECT]: 'layersPanelTypeRect',
  [TOOLS_IDS.ELLIPSE]: 'layersPanelTypeEllipse',
  [TOOLS_IDS.POLYGON]: 'layersPanelTypePolygon',
  [TOOLS_IDS.STAR]: 'layersPanelTypeStar',
  [TOOLS_IDS.LINE]: 'layersPanelTypeLine',
  [TOOLS_IDS.ARROW]: 'layersPanelTypeArrow',
  [TOOLS_IDS.PEN]: 'layersPanelTypePen',
};

const truncate = (value, max = 28) => {
  const text = String(value || '').trim();
  if (!text) {
    return '';
  }
  return text.length > max ? `${text.slice(0, max - 1)}…` : text;
};

/**
 * @param {object} annotation
 * @param {(key: string) => string} t
 */
export const getLayerDisplayLabel = (annotation, t) => {
  if (!annotation) {
    return '';
  }

  if (annotation.id === WATERMARK_ANNOTATION_ID) {
    return t('layersPanelWatermark');
  }

  if (annotation.name === TOOLS_IDS.TEXT) {
    const textLabel = truncate(annotation.text);
    return textLabel || t(TOOL_LABEL_KEYS[TOOLS_IDS.TEXT]);
  }

  const typeKey = TOOL_LABEL_KEYS[annotation.name];
  return typeKey ? t(typeKey) : annotation.name || t('layersPanelTypeLayer');
};

export default getLayerDisplayLabel;
